import { Component, ElementRef, OnInit } from "@angular/core";

@Component({
    selector: 'newsroom-page-header',
    templateUrl: './newsroom-page-header.component.html',
    styles: [],
})

export class NewsroomPageHeaderComponent implements OnInit {
    public title: string | null = null;

    constructor(private elementRef: ElementRef) { }

    ngOnInit(): void {
        this.title = this.elementRef.nativeElement.getAttribute('page-title');
    }
}
